import { gql, useQuery } from '@apollo/client'

const QUESTION_DETAIL_QUERY = gql`
  query QuestionDetail($questionId: Long!) {
    question(id: $questionId) {
      id
      type
      text
      textFuture
      threshold
      description
      associatedLink
      notApplicable
      dimension {
        id
        name
      }
      options {
        value
      }
      recommendations {
        stage {
          id
          name
        }
        above
        bellow
      }
    }
  }
`

export function useQuestionDetailQuery(questionId, options = {}) {
  const { data, ...rest } = useQuery(QUESTION_DETAIL_QUERY, {
    ...options,
    variables: {
      ...options.variables,
      questionId
    }
  })

  return {
    data: data?.question,
    ...rest
  }
}
